"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _colorUtils = require("../../utils/colorUtils");
var _getRgbaFromHex = _interopRequireDefault(require("../../utils/getRgbaFromHex"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var Pagination = {
  styles: function styles(theme) {
    return {
      pageIndicator: {
        color: theme.colors.baseContrast060
      },
      activePageIndicator: {
        color: (0, _getRgbaFromHex.default)(theme.colors.textOnDark, 0.9)
      },
      pageChanger: {
        backgroundColor: "transparent",
        "&:hover": {
          // hover state background color for prev/next
          backgroundColor: theme.colors.baseContrast020,
          "& $pageChangerIcon": {
            // hover state icon color for prev/next
            fill: (0, _colorUtils.getHoverColor)(theme.colors.primary).toHexString()
          }
        }
      }
    };
  }
};
var _default = exports.default = Pagination;